// API URL helper - handles both dev and production deployments
// In production (Railway), REACT_APP_BACKEND_URL might be empty for same-origin deployment
const getApiUrl = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  // If empty or undefined, use relative path (same-origin)
  if (!backendUrl || backendUrl === '' || backendUrl === 'undefined') {
    return '/api';
  }
  return `${backendUrl}`;
};

export const API = getApiUrl();
export default API;
